/* eslint-disable max-classes-per-file */

import Base from 'requests/objects/_base'

/**
 * Collaborator Object
 */
export default class Collaborator extends Base {
    /**
     * @param {object} data data
     * @param {string=} data.registrationNumber registrationNumber
     * @param {string=} data.matricule matricule
     * @param {boolean=} data.isSelected isSelected
     * @param {string=} data.companyCode companyCode
     * @param {string=} data.title title
     * @param {string=} data.lastname lastname
     * @param {string=} data.firstname firstname
     * @param {string=} data.jType jType
     */
    constructor({
        registrationNumber = '',
        matricule = '',
        isSelected = false,
        companyCode = '',
        title = '',
        lastname = '',
        firstname = '',
        jType = '',
        ...data
    } = {}) {
        super(data)
        this.registrationNumber = registrationNumber
        this.matricule = matricule
        this.isSelected = isSelected
        this.companyCode = companyCode
        this.title = title
        this.lastname = lastname
        this.firstname = firstname
        this.jType = jType
    }
}
